import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronLeftCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 16a12 12 0 1 1-23.999 0A12 12 0 0 1 28 16m2 0a14 14 0 1 0-28 0 14 14 0 0 0 28 0" />
    <path d="M18.7 22.7a1 1 0 0 0 0-1.4L13.4 16l5.3-5.3a1 1 0 0 0 0-1.4 1 1 0 0 0-1.4 0l-6 6a1 1 0 0 0 0 1.4l6 6a1 1 0 0 0 1.4 0" />
  </svg>
);
const ForwardRef = forwardRef(IconChevronLeftCircleOutlineSVG);
ForwardRef.displayName = "IconChevronLeftCircleOutline";
export { ForwardRef as IconChevronLeftCircleOutline };
